<div class="step-container">
  <h2 class="step-titulo">
    <span *ngIf="ehModoManual && caminhoEscolhido !== 'planilha'">Cadastre seus produtos</span>
    <span *ngIf="caminhoEscolhido === 'planilha'">Produtos importados da planilha</span>
    <span *ngIf="ehModoTemplate">Revise os produtos de exemplo</span>
    <span *ngIf="caminhoEscolhido === 'importar'">Revise os produtos importados</span>
  </h2>
  <p class="step-subtitulo">
    <span *ngIf="ehModoManual && caminhoEscolhido !== 'planilha'">Adicione pelo menos 1 produto para começar.</span>
    <span *ngIf="caminhoEscolhido === 'planilha'">Adicione produtos manualmente ou faça o upload de uma planilha em breve.</span>
    <span *ngIf="ehModoTemplate">
      Esses são produtos de exemplo do seu segmento. Edite ou remova o que quiser.
    </span>
    <span *ngIf="caminhoEscolhido === 'importar'">
      Desmarque os produtos que não deseja manter.
    </span>
  </p>

  <!-- Template / Importados: lista com review -->
  <div *ngIf="!ehModoManual">
    <div class="opcao-limpeza" *ngIf="caminhoEscolhido === 'importar'">
      <label class="opcao-limpeza__label" [class.disabled]="!podeLimparCatalogoExistente">
        <input
          type="checkbox"
          [disabled]="!podeLimparCatalogoExistente || salvandoSelecao"
          [(ngModel)]="limparCatalogoExistente">
        <span class="opcao-limpeza__texto">
          <strong>Limpar o cardápio existente antes de importar</strong>
          <span *ngIf="carregandoResumoCatalogo">Verificando itens atuais...</span>
          <span *ngIf="!carregandoResumoCatalogo && totalProdutosCatalogoAtual > 0">
            O catálogo atual tem {{ totalProdutosCatalogoAtual }} item(ns) e eles serão removidos antes da nova importação.
          </span>
          <span *ngIf="!carregandoResumoCatalogo && totalProdutosCatalogoAtual === 0">
            Seu catálogo atual está vazio, então não há nada para limpar.
          </span>
        </span>
      </label>
    </div>

    <div class="resumo-importacao">
      <div class="resumo-card">
        <span class="resumo-label">Selecionados</span>
        <strong class="resumo-valor">{{ produtosSelecionados.length }}</strong>
      </div>
      <div class="resumo-card">
        <span class="resumo-label">Categorias</span>
        <strong class="resumo-valor">{{ totalCategoriasSelecionadas }}</strong>
      </div>
      <div class="resumo-card" *ngIf="produtosRemovidos.length > 0">
        <span class="resumo-label">Ocultos agora</span>
        <strong class="resumo-valor">{{ produtosRemovidos.length }}</strong>
      </div>
    </div>

    <div class="produtos-toolbar" *ngIf="ehModoTemplate">
      <span class="produtos-count">{{ produtosSelecionados.length }} de {{ produtos.length }} selecionados</span>
      <div class="toolbar-actions">
        <button class="btn-toolbar" (click)="selecionarTodosExemplos()">Selecionar todos</button>
        <button class="btn-toolbar danger" (click)="removerTodosExemplos()">Remover todos</button>
      </div>
    </div>

    <div class="categoria-grupo" *ngFor="let cat of categorias">
      <div class="categoria-header">
        <div>
          <h4 class="categoria-nome">{{ cat }}</h4>
          <p class="categoria-meta">{{ produtosPorCategoria(cat).length }} item(ns) nesta categoria</p>
        </div>
        <button class="btn-link-categoria" *ngIf="categoriaTemMaisProdutos(cat)" (click)="toggleCategoria(cat)">
          {{ categoriaExpandida(cat) ? 'Mostrar menos' : ('Ver todos (' + produtosPorCategoria(cat).length + ')') }}
        </button>
      </div>
      <div class="produtos-lista">
        <div class="produto-item"
             *ngFor="let p of produtosVisiveisPorCategoria(cat)"
             [class.desmarcado]="!p.selecionado">
          <div class="produto-check" (click)="toggleProduto(p)">
            <i class="fe-check" *ngIf="p.selecionado"></i>
          </div>
          <div class="produto-info">
            <span class="produto-nome">
              {{ p.nome }}
              <span class="badge-exemplo" *ngIf="p.exemplo">Exemplo</span>
            </span>
            <span class="produto-descricao">{{ p.descricao }}</span>
          </div>
          <span class="produto-preco">R$ {{ p.preco | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>

    <!-- Produtos desmarcados -->
    <div class="produtos-desmarcados" *ngIf="produtosRemovidos.length > 0">
      <div class="categoria-header">
        <div>
          <h4 class="categoria-nome text-muted">Removidos por enquanto</h4>
          <p class="categoria-meta">{{ produtosRemovidos.length }} item(ns) fora desta primeira importação</p>
        </div>
        <button class="btn-link-categoria" *ngIf="haMaisRemovidos" (click)="removidosExpandidos = !removidosExpandidos">
          {{ removidosExpandidos ? 'Mostrar menos' : ('Ver todos (' + produtosRemovidos.length + ')') }}
        </button>
      </div>
      <div class="produtos-lista">
        <div class="produto-item desmarcado"
             *ngFor="let p of produtosRemovidosVisiveis">
          <div class="produto-check" (click)="toggleProduto(p)">
            <i class="fe-plus"></i>
          </div>
          <div class="produto-info">
            <span class="produto-nome">{{ p.nome }}</span>
          </div>
          <span class="produto-preco">R$ {{ p.preco | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Modo manual: formulário -->
  <div *ngIf="ehModoManual">
    <div class="manual-form">
      <div class="form-group mb-2">
        <label class="campo-label">Nome do produto</label>
        <input type="text" class="campo-input" [(ngModel)]="produtoManual.nome"
               placeholder="Ex: X-Burger" (keyup.enter)="adicionarProdutoManual()">
      </div>
      <div class="form-group mb-2">
        <label class="campo-label">Descrição</label>
        <input type="text" class="campo-input" [(ngModel)]="produtoManual.descricao"
               placeholder="Ingredientes ou detalhes">
      </div>
      <div class="form-group mb-3">
        <label class="campo-label">Preço (R$)</label>
        <input type="number" class="campo-input" [(ngModel)]="produtoManual.preco"
               placeholder="0.00" [min]="0" (keyup.enter)="adicionarProdutoManual()">
      </div>

      <p class="text-danger" *ngIf="erroManual">
        <i class="fe-alert-circle mr-1"></i> {{ erroManual }}
      </p>

      <button class="btn-adicionar"
              [disabled]="!produtoManual.nome || !produtoManual.preco || salvandoManual"
              (click)="adicionarProdutoManual()">
        <i class="fe-plus mr-1"></i>
        {{ salvandoManual ? 'Salvando...' : 'Adicionar produto' }}
      </button>
    </div>

    <div class="produtos-manuais-lista" *ngIf="produtosManuais.length > 0">
      <h4 class="categoria-nome mt-4">Produtos adicionados ({{ produtosManuais.length }})</h4>
      <div class="produtos-lista">
        <div class="produto-item" *ngFor="let p of produtosManuais; let i = index">
          <div class="produto-info">
            <span class="produto-nome">{{ p.nome }}</span>
            <span class="produto-descricao">{{ p.descricao }}</span>
          </div>
          <span class="produto-preco">R$ {{ p.preco | number:'1.2-2' }}</span>
          <button class="btn-remover-produto" (click)="removerProdutoManual(i)">
            <i class="fe-trash-2"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="step-actions">
    <button class="btn-anterior" (click)="voltar()">
      <i class="fe-arrow-left mr-1"></i> Anterior
    </button>
    <div class="d-flex flex-column align-items-end">
      <div class="progresso-importacao" *ngIf="salvandoSelecao">
        <div class="progresso-importacao__header">
          <strong>
            {{ faseImportacao === 'limpando' ? 'Limpando catálogo' : 'Importando produtos' }}
            {{ processadosSalvar }} de {{ totalSalvar }}
          </strong>
          <span>{{ progressoImportacaoPercentual }}%</span>
        </div>
        <div class="progresso-importacao__barra">
          <div class="progresso-importacao__fill" [style.width.%]="progressoImportacaoPercentual"></div>
        </div>
        <p class="progresso-importacao__texto" *ngIf="produtoImportandoAtual">
          {{ produtoImportandoAtual }}
        </p>
      </div>
      <p class="text-danger mb-1" *ngIf="erroValidacao">
        <i class="fe-alert-circle mr-1"></i> {{ erroValidacao }}
      </p>
      <p class="text-danger mb-1" *ngIf="erroImportacao">
        <i class="fe-alert-circle mr-1"></i> {{ erroImportacao }}
      </p>
      <button class="btn-proximo" [disabled]="salvandoSelecao" (click)="avancar()">
        {{ salvandoSelecao ? 'Salvando produtos...' : 'Próximo' }} <i class="fe-arrow-right ml-1"></i>
      </button>
    </div>
  </div>
</div>
